import {
	AppBar,
	Container,
	makeStyles,
	Toolbar,
	Typography,
} from '@material-ui/core';
import { grey } from '@material-ui/core/colors';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import { ArrowBack } from '@material-ui/icons';
import React from 'react';
import { useHistory } from 'react-router-dom';
import theme from '../../theme';

export type BackBannerProps = {
	title: string;
};

const useStyles = makeStyles({
	banner: {
		borderRadius: '5px',
		backgroundColor: theme.palette.secondary.dark,
		boxShadow: `1px 1px 3px -1px ${theme.palette.common.black}`,
		display: 'flex',
		justifyContent: 'center',
		textAlign: 'center',
	},
	title: {
		color: 'white',
		margin: '0 auto',
		marginTop: '10px'
	},
	backButton: {
		color: 'white',
	},
});

const BackBanner = (props: BackBannerProps) => {
	const classes = useStyles();
	const history = useHistory();

	const handleBackButton = () => {
		history.goBack();
	};

	return (
		<>
			<Toolbar className={classes.banner}>
				<Grid container xs={12} spacing={0}>
					<Grid item xs={1}>
					<IconButton
					onClick={handleBackButton}
					edge='start'
					aria-label='menu'
					className={classes.backButton}
				>
					<ArrowBack />
				</IconButton>
			
					</Grid>
					<Grid item xs={10}>
					<Typography
					className={classes.title}
					variant='h5'
					color='inherit'
				>
					{props.title}
				</Typography>
					</Grid>
				</Grid>
		
			</Toolbar>
		</>
	);
};

export default BackBanner;
